// Tarjetas con el conteo por valor de un campo (estado, permiso...).
// Al hacer clic en una tarjeta se filtra la tabla; otro clic quita el filtro.

export const aplicarFiltrosTarjetas = (datos, filtros) =>
  datos.filter((fila) =>
    Object.entries(filtros).every(
      ([campo, valor]) => !valor || (fila[campo] || "Sin dato") === valor
    )
  );

const FiltrosTarjetas = ({ datos, grupos, filtros, setFiltros }) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 24px", alignItems: "center" }}>
    {grupos.map(({ campo, etiqueta }) => {
      // El conteo de cada grupo respeta los filtros de los demás grupos.
      const base = aplicarFiltrosTarjetas(datos, { ...filtros, [campo]: null });
      const conteo = base.reduce((acc, fila) => {
        const valor = fila[campo] || "Sin dato";
        acc[valor] = (acc[valor] || 0) + 1;
        return acc;
      }, {});

      return (
        <div key={campo} style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontWeight: 600, fontSize: 14, color: "#555" }}>{etiqueta}:</span>
          {Object.entries(conteo)
            .sort((a, b) => b[1] - a[1])
            .map(([valor, cantidad]) => {
              const activo = filtros[campo] === valor;
              return (
                <div
                  key={valor}
                  onClick={() => setFiltros((prev) => ({ ...prev, [campo]: activo ? null : valor }))}
                  title={activo ? "Clic para quitar el filtro" : "Clic para filtrar"}
                  style={{
                    padding: "6px 14px",
                    borderRadius: 20,
                    background: activo ? "#0d6efd" : "#f0f0f0",
                    color: activo ? "#fff" : "#000",
                    fontWeight: "bold",
                    fontSize: 14,
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  {valor}: {cantidad}
                </div>
              );
            })}
        </div>
      );
    })}
  </div>
);

export default FiltrosTarjetas;
